module.exports = __webpack_public_path__ + "static/media/9. La creación, Mixta en tela, 140 x 180 cm, 2015 copy.dc56e17d.png";